// extracted by mini-css-extract-plugin
export default {"container":"o8F38","bottom":"tOCM5"};